import { AUTH_STORAGE_KEY } from '../constants/app'

function parseSession(rawSession, storage) {
  if (!rawSession) return null

  try {
    const session = JSON.parse(rawSession)
    if (!session?.access_token || !session?.user) {
      storage.removeItem(AUTH_STORAGE_KEY)
      return null
    }

    return session
  } catch {
    storage.removeItem(AUTH_STORAGE_KEY)
    return null
  }
}

export function readStoredSession() {
  return (
    parseSession(localStorage.getItem(AUTH_STORAGE_KEY), localStorage) ||
    parseSession(sessionStorage.getItem(AUTH_STORAGE_KEY), sessionStorage)
  )
}

export function storeSession(session, remember = true) {
  const rawSession = JSON.stringify(session)

  if (remember) {
    localStorage.setItem(AUTH_STORAGE_KEY, rawSession)
    sessionStorage.removeItem(AUTH_STORAGE_KEY)
    return
  }

  sessionStorage.setItem(AUTH_STORAGE_KEY, rawSession)
  localStorage.removeItem(AUTH_STORAGE_KEY)
}

export function clearStoredSession() {
  localStorage.removeItem(AUTH_STORAGE_KEY)
  sessionStorage.removeItem(AUTH_STORAGE_KEY)
}

export function getAccessToken(session = readStoredSession()) {
  return session?.access_token || null
}
